import { useCallback } from "react";
import type { TreeNodeData } from "../TreeViewDataLayer";

interface UseVolumeFilteringProps {
  hideZeroVolumeAbos: boolean;
}

interface UseVolumeFilteringReturn {
  filterZeroVolumeData: (data: TreeNodeData | null) => TreeNodeData | null;
}

const isZeroVolume = (node: TreeNodeData): boolean => node.kpis.PersonalPV.Raw === 0 && node.kpis.GroupPV.Raw === 0;

/**
 * Hook to hide zero-volume ABOs from the tree, mirroring the legacy Lit grid's
 * "Hide ABOs With Zero Volume" toggle. The root node is always kept regardless
 * of its own volume, matching the legacy grid's behavior of always including
 * the logged-in ABO's own row.
 */
export const useVolumeFiltering = ({ hideZeroVolumeAbos }: UseVolumeFilteringProps): UseVolumeFilteringReturn => {
  const filterZeroVolumeData = useCallback(
    (data: TreeNodeData | null): TreeNodeData | null => {
      if (!data || !hideZeroVolumeAbos) return data;

      const filterNode = (node: TreeNodeData): TreeNodeData => ({
        ...node,
        downlines: node.downlines?.filter((child) => !isZeroVolume(child)).map(filterNode),
      });

      return filterNode(data);
    },
    [hideZeroVolumeAbos],
  );

  return { filterZeroVolumeData };
};
